import { PermissionsEnum } from '../../../constants'

export interface PermissionResponse {
  permitted: boolean
  request: {
    orgUnit?: string
    permission: PermissionsEnum
  }
}

export enum ApexLegitAuthorization {
  Loading = 'APEX_LEGIT_AUTHORIZATION/LOADING',
  NotAsked = 'APEX_LEGIT_AUTHORIZATION/NOT_ASKED',
  Success = 'APEX_LEGIT_AUTHORIZATION/SUCCESS',
}

export const AUTH_LOADING_STATE = [
  ApexLegitAuthorization.Loading,
  ApexLegitAuthorization.NotAsked,
]
